import { combineReducers } from 'redux';
import mainReducer from './reducers';


export default combineReducers({
    main: mainReducer
});
